import { baseApi } from '@shared/api'

const businessDateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchBusinessDate: builder.mutation<any, void>({
      query: () => ({
        isGw: false,
        url: 'bank/bussinessdate',
        method: 'GET',
      }),
    }),
  }),
})

export const { useFetchBusinessDateMutation } = businessDateApi
